import React from "react";
import Marquee from "react-fast-marquee";
import godrej from "../../assets/brands/Logo_for_Maruti_Suzuki.svg.png";
import lnt from "../../assets/brands/Mahindra-Logo.png";
import dlf from "../../assets/brands/images__2_-removebg-preview.png";
import max from "../../assets/brands/images__3_-removebg-preview.png";
import ace from "../../assets/brands/images-removebg-preview.png";
import tyota from "../../assets/brands/images__4_-removebg-preview.png";
import { Helmet } from "react-helmet";

export const Partners = () => {
  return (
    <>
      <Helmet>
        <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
        <meta
          name="description"
          content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
        />
        <meta
          name="keywords"
          content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
        />
        <meta name="author" content="The Best Cab Jaipur" />
      </Helmet>
      <div className="px-6 py-10 bg-gray-100">
        <h3 className="text-3xl text-center font-bold text-gray-800 mb-5">
          Our Trusted Travel Partners
        </h3>
        <p className="text-center text-gray-600">
          Partnering with Leading Automotive Brands to Ensure a Safe & Comfortable Journey!
        </p>
        <div className="marquee-container py-5 px-4 sm:px-10">
          <Marquee direction="left" speed={50} pauseOnHover={true}>
            {[dlf, lnt, godrej, max, ace, tyota].map((brand, index) => (
              <div key={index} className="mx-4 sm:mx-6 flex items-center">
                <img src={brand} alt="Brand Logo" className="w-28 sm:w-36 md:w-44 lg:w-52" />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </>
  );
};
